import React from 'react';
import { PlusCircle, Edit, Trash2, BookOpen } from 'lucide-react';
import { getLevelStyling } from '../utils/roadmapStylingHelper';

const RoadmapLevelList = ({
  levels,
  setSelectedLevel,
  handleEditLevel,
  handleDeleteLevel,
  handleOpenAddLevelModal, // Updated prop name to be more descriptive
}) => {
  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-teal-400 to-green-400 bg-clip-text text-transparent">
          Coaching Levels
        </h1>
        <button
          onClick={handleOpenAddLevelModal} // Updated to use the new handler
          className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 rounded-lg text-sm font-medium transition-all duration-200"
        >
          <PlusCircle className="w-5 h-5" /> Add New Level
        </button>
      </div>

      <div className="space-y-4">
        {levels.length === 0 ? (
          <div className="text-center py-12 text-slate-500">
            <p>No coaching levels defined yet. Add one to get started!</p>
          </div>
        ) : (
          levels.map((level) => {
            const { iconBg } = getLevelStyling(level.order);
            return (
              <div
                key={level.id}
                className="bg-slate-800 rounded-xl p-6 border border-slate-700 hover:border-slate-600 transition-colors flex justify-between items-center"
              >
                <div className="flex items-center space-x-4">
                  <div className={`w-12 h-12 ${iconBg} rounded-full flex items-center justify-center text-white font-bold text-lg`}>
                    {level.order}
                  </div>
                  <div>
                    <h3 className="text-start text-lg font-semibold text-white">{level.name}</h3>
                    <p className="text-slate-400 text-sm">{level.subtitle}</p>
                    <p className="text-start text-slate-500 text-xs mt-1">({level.items.length} sessions)</p>
                  </div>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => setSelectedLevel(level)}
                    className="p-2 text-blue-400 hover:text-blue-200 hover:bg-slate-700 rounded-lg transition-colors flex items-center gap-1 text-sm"
                  >
                    <BookOpen className="w-5 h-5" /> View Sessions
                  </button>
                  <button
                    onClick={() => handleEditLevel(level)}
                    className="p-2 text-yellow-400 hover:text-yellow-200 hover:bg-slate-700 rounded-lg transition-colors"
                  >
                    <Edit className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => handleDeleteLevel(level.id)}
                    className="p-2 text-red-400 hover:text-red-200 hover:bg-slate-700 rounded-lg transition-colors"
                  >
                    <Trash2 className="w-5 h-5" />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default RoadmapLevelList;
